export default "__VITE_ASSET__BhoUxDU9__"